module.exports = __webpack_public_path__ + "static/Norton-Logo-1628909568f011ff50e14453241ad67a.svg";